import { render, staticRenderFns } from "./TruformePayInvoice.vue?vue&type=template&id=b79f2c9e"
import script from "./TruformePayInvoice.vue?vue&type=script&lang=js"
export * from "./TruformePayInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports